import { defineMessages } from 'react-intl-next';

export default defineMessages({
    genericHeading: {
        defaultMessage: 'Something bad happened',
        description: 'Generic error when something could not be loaded',
        id: 'cv.portal.topic.error-page.generic.error.heading',
    },
    genericMessage: {
        defaultMessage: 'Looks like we’re having trouble retrieving some information, please refresh the page.',
        description: 'Generic error when something could not be loaded',
        id: 'cv.portal.topic.error-page.generic.error.message',
    },
});
